import React, { Component } from 'react'
import Select from 'react-select'
import GlobalHelper from "../GlobalHelper.jsx";
import { injectIntl } from "react-intl";

class MultiLanguageSelect extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            options: [],
            selectedOptions: this.props.value || [],
            exclude: this.props.exclude || []
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOptions) {
        this.setState({
            selectedOptions: selectedOptions
        }, () => {
            this.onChange(selectedOptions.map(option => option.value))
        });
    }

    loadLanguages() {
        this.setState({
            options: GlobalHelper.getSupportedLanguages().filter(language =>
                !this.state.exclude.includes(language)).map(language => {
                    return {
                        value: language,
                        label: this.props.intl.formatMessage(GlobalHelper.getLanguageMessage(language))
                    }
                }),
        })
    }

    componentDidMount() {
        this.loadLanguages()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOptions) {
            this.setState({
                selectedOptions: nextProps.value.filter(option => option !== nextProps.exclude) || [],
                exclude: nextProps.exclude || []
            }, () => {
                this.loadLanguages()
            })
        }
    }

    render() {
        return (
            <Select
                name={this.name}
                multi
                placeholder={this.placeholder}
                value={this.state.selectedOptions}
                onChange={this.handleChange}
                options={this.state.options}
            />
        )
    }
}

export default injectIntl(MultiLanguageSelect)





// WEBPACK FOOTER //
// ./src/common/language/multiselect.component.jsx